import React from 'react';

const benefits = [
  {
    text: 'Aparecer mejor posicionado en búsquedas',
  },
  {
    text: 'Destacarse frente a otros alojamientos',
  },
  {
    text: 'Tener presencia en listados y acciones de temporada',
  },
  {
    text: 'Aprovechar el pico real de demanda',
  },
];

const CampanaWhatIs = () => {
  return (
    <section className="campana-what-is">
      <div className="campana-what-is__container">
        <div className="campana-what-is__header">
          <h2 className="campana-what-is__title">¿Qué es esta campaña?</h2>
          <p className="campana-what-is__subtitle">
            La campaña de visibilidad Alohar es un{' '}
            <span className="campana-what-is__highlight">refuerzo temporal de exposición</span>, diseñado para:
          </p>
        </div>

        <div className="campana-what-is__benefits">
          {benefits.map((benefit, index) => (
            <div key={index} className="campana-what-is__benefit">
              <div className="campana-what-is__benefit-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                  <polyline points="16 7 22 7 22 13" />
                </svg>
              </div>
              <p className="campana-what-is__benefit-text">{benefit.text}</p>
            </div>
          ))}
        </div>

        <div className="campana-what-is__callout">
          <p className="campana-what-is__callout-text">
            <span className="campana-what-is__callout-bold">Estar publicado no garantiza ser visto.</span>
            <br />
            Esta campaña existe para eso.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CampanaWhatIs;
